import { Autocomplete, Box, InputBase, createStyles } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { styled } from '@mui/system';
import { useTranslation } from 'react-i18next';
import { customStyle, theme } from 'components/shared/DropDown/CustomAutocompleteStyle';
import * as React from 'react';
import { ThemeProvider } from '@mui/material/styles';

const useStyles = makeStyles(() => createStyles(customStyle));

export const CustomLanguageAutocomplete = (props) => {
    const classes = useStyles();
    const { t } = useTranslation();

    const GroupHeader = styled('div')(() => ({
        position: 'sticky',
        top: '-8px',
        padding: '4px 10px',
        backgroundColor: '#A89DF7',
    }));

    const GroupItems = styled('ul')({
        padding: 0,
    });

    return (
        <ThemeProvider theme={theme}>
            <Autocomplete
                options={props.list || []}
                disabled={props.disabled}
                defaultValue={props.value ?? null}
                isOptionEqualToValue={(option, value) => option === value}
                value={props.value ?? null}
                noOptionsText={t("Pas d'options")}
                getOptionLabel={(option) => (option ? props.getOptionLabel(option) : '')}
                fullWidth
                classes={{
                    option: classes.option,
                    clearIndicatorDirty: classes.clearIndicator,
                    popupIndicator: classes.popupIndicator,
                }}
                className={props.className || ''}
                onChange={(event, value) => props.setValue(value)}
                getOptionDisabled={(option) =>
                    props.getOptionDisabled ? props.getOptionDisabled(option) : false
                }
                groupBy={(option) => option.availabilityGroup}
                renderGroup={(params) =>
                    props.isWriterList ? (
                        <li key={params.key}>
                            <GroupHeader>{params.group}</GroupHeader>
                            <GroupItems>{params.children}</GroupItems>
                        </li>
                    ) : (
                        <div key={params.key}>
                            <div>{params.group}</div>
                            <div>{params.children}</div>
                        </div>
                    )
                }
                renderOption={(_props, option) => {
                    const optionStyle =
                        props.isWriterList && !option.isAvailable ? { color: 'gray' } : {};

                    const endAdornment =
                        typeof props.renderOptionEnd === 'function' ? (
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                {props.renderOptionEnd(option)}
                            </Box>
                        ) : null;

                    return (
                        <Box
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                width: '100%',
                                ...optionStyle,
                            }}
                            {..._props}
                        >
                            <Box>
                                {typeof props.renderOptionLabel === 'function'
                                    ? props.renderOptionLabel(option)
                                    : props.getOptionLabel(option)}
                            </Box>
                            <Box>{endAdornment}</Box>
                        </Box>
                    );
                }}
                renderInput={(params) => {
                    const { InputLabelProps, InputProps, ...rest } = params;
                    const mergedInputProps = {
                        ...params.InputProps,
                        ...(props.renderInputEnd && {
                            endAdornment: (
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    {typeof props.renderInputEnd === 'function'
                                        ? props.renderInputEnd()
                                        : props.renderInputEnd}
                                    {params.InputProps?.endAdornment}
                                </Box>
                            ),
                        }),
                    };
                    return (
                        <InputBase
                            classes={{
                                root: `${classes.root} ${props.inputClassName || ''}`.trim(),
                            }}
                            variant="outlined"
                            placeholder={props.placeholder || ''}
                            sx={{
                                width: '100%',
                                height: '32px',
                                padding: '7px 10px',
                                borderRadius: '5px',

                                border: '1px solid #E9E9E9',

                                fontFamily: "'Poppins', sans-serif",
                                fontWeight: 400,
                                fontSize: '12px',
                                lineHeight: '100%',
                                letterSpacing: '0px',
                                color: '#1A1A1A',
                                boxSizing: 'border-box',
                                outline: 'none',
                                transition: 'border-color 0.15s ease',
                                '&:hover': { borderColor: '#d0d0d0' },
                                '&.Mui-focused': { borderColor: '#A89DF7' },
                            }}
                            {...mergedInputProps}
                            {...rest}
                        />
                    );
                }}
            />
        </ThemeProvider>
    );
};